// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: oUG6N5k-MozB
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import SignOutButton from "../../SignOutButton"; // plasmic-import: T8DJa973Q48i/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicSignOutElement.module.css"; // plasmic-import: oUG6N5k-MozB/css
import Rect3338Icon from "./icons/PlasmicIcon__Rect3338"; // plasmic-import: kwdRRkFFLV8f/icon

createPlasmicElementProxy;

export const PlasmicSignOutElement__VariantProps = new Array("postClick");

export const PlasmicSignOutElement__ArgProps = new Array();

const $$ = {};

function PlasmicSignOutElement__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "postClick",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.postClick
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (hasVariant($state, "postClick", "postClick") ? true : false) ? (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root,
        { [sty.rootpostClick]: hasVariant($state, "postClick", "postClick") }
      )}
    >
      <Rect3338Icon
        data-plasmic-name={"svg"}
        data-plasmic-override={overrides.svg}
        className={classNames(projectcss.all, sty.svg)}
        role={"img"}
      />

      <SignOutButton
        data-plasmic-name={"signOutButton"}
        data-plasmic-override={overrides.signOutButton}
        className={classNames("__wab_instance", sty.signOutButton, {
          [sty.signOutButtonpostClick]: hasVariant(
            $state,
            "postClick",
            "postClick"
          )
        })}
        postClick={
          hasVariant($state, "postClick", "postClick") ? true : undefined
        }
      />
    </div>
  ) : null;
}

const PlasmicDescendants = {
  root: ["root", "svg", "signOutButton"],
  svg: ["svg"],
  signOutButton: ["signOutButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSignOutElement__ArgProps,
          internalVariantPropNames: PlasmicSignOutElement__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSignOutElement__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSignOutElement";
  } else {
    func.displayName = `PlasmicSignOutElement.${nodeName}`;
  }
  return func;
}

export const PlasmicSignOutElement = Object.assign(
  // Top-level PlasmicSignOutElement renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    svg: makeNodeComponent("svg"),
    signOutButton: makeNodeComponent("signOutButton"),
    // Metadata about props expected for PlasmicSignOutElement
    internalVariantProps: PlasmicSignOutElement__VariantProps,
    internalArgProps: PlasmicSignOutElement__ArgProps
  }
);

export default PlasmicSignOutElement;
/* prettier-ignore-end */
